<template>
  <b-button v-bind="$attrs" class="btn stripe-btn" :variant="variant" @click="onClickEvent">
    <slot />
  </b-button>
</template>

<script lang="ts">
import type { ButtonVariant } from 'bootstrap-vue-next'
import { defineComponent, type PropType } from 'vue'

export default defineComponent({
  name: 'StripeBtn',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String as PropType<ButtonVariant>,
      default: 'outline-secondary',
    },
  },
  emits: ['click'],
  setup(_, { emit }) {
    const onClickEvent = () => {
      emit('click')
    }

    return {
      onClickEvent,
    }
  },
})
</script>
